
import mutations from './mutations'
import getters from './getters'
import state from './state'

export default {
  mutations,
  getters,
  state,
  namespaced: true,
}